import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService, UserIdService } from '@spartacus/core';
import { CustomActiveCartService } from '../../../../_core/active-cart.service';
import { catchError, combineLatest, map, Observable, switchMap } from 'rxjs';
import { ProductAllowedQuantityRequest } from '../../../../_core/quantiProduct.model';
import { failStatus, successStatus } from '../../../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class ProductAllowedQuantityAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
    private userIdService: UserIdService,
    private customActiveCartService: CustomActiveCartService,
  ) {}

  checkProductAllowedQuantity(): Observable<ProductAllowedQuantityRequest> {
    return combineLatest([this.userIdService.getUserId(), this.customActiveCartService.getActiveCartId()]).pipe(
      switchMap(([userId, cartId]) => {
        const url = this.occEndPointService.buildUrl('validateMOQ', { urlParams: { userId, cartId } });

        return this.http.get(url).pipe(
          map((response: any) => {
            return {
              ...{
                productChanges: response,
              },
              ...successStatus,
            };
          }),
          catchError(() => {
            return this.translationService.translate('generic.error').pipe(
              map(textError => ({
                message: textError,
                ...failStatus,
              })),
            );
          }),
        );
      }),
    );
  }
}
